import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardDossierStatesDefinition } from '../create-dossier-states-definition';
import { DossierShell } from '../dossier-shell.profile';
import {
  DossierDevelopmentMetricProfile,
  dossierDevelopmentEconomicParticipantProfile,
  dossierDevelopmentEmployedProfile,
  dossierDevelopmentGvaProfile,
  dossierDevelopmentRevenueProfile,
  dossierDevelopmentTaxedProfile,
} from './dashboard-dossier-states-development-metric.profile';
import { DashboardDossierStatesDevelopmentDefinition } from './dashboard-dossier-states-development.definition';

/**
 * Product catalog for dossier states development (entwicklung).
 * Identity is derived in {@link createDashboardDossierStatesDefinition}.
 */

// Pending datasets: Tourism and SelfEmployed dossiers.
type DossierDevelopmentMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed
>;

export const DOSSIER_STATES_DEVELOPMENT_PRODUCT_CATALOG: Record<
  DossierDevelopmentMetric,
  ProductCatalogEntry<DossierDevelopmentMetricProfile, DossierShell>
> = {
  [Metric.CompaniesCount]: {
    metric: dossierDevelopmentTaxedProfile,
    shells: ['development'],
  },
  [Metric.CompaniesRevenue]: {
    metric: dossierDevelopmentRevenueProfile,
    shells: ['development'],
  },
  [Metric.GrossValueAdded]: {
    metric: dossierDevelopmentGvaProfile,
    shells: ['development'],
  },
  [Metric.EconomicParticipant]: {
    metric: dossierDevelopmentEconomicParticipantProfile,
    shells: ['development'],
  },
  [Metric.Employed]: {
    metric: dossierDevelopmentEmployedProfile,
    shells: ['development'],
  },
};

/** All dossier states development (entwicklung) product definitions. */
export const DOSSIER_STATES_DEVELOPMENT_DEFINITIONS: DashboardDossierStatesDevelopmentDefinition[] =
  expandProductCatalog(
    Object.values(DOSSIER_STATES_DEVELOPMENT_PRODUCT_CATALOG),
    createDashboardDossierStatesDefinition,
  );
